import React, { useState } from 'react';
import { useCSVExport, ExportFilters } from '../services/csvExport';

interface ExportButtonProps {
  type: 'campaigns' | 'revenue-per-day' | 'overview';
  filters: ExportFilters;
  className?: string;
  children?: React.ReactNode;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ 
  type, 
  filters, 
  className = '', 
  children 
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const { exportData } = useCSVExport();

  const handleExport = async () => {
    setIsExporting(true);
    
    try {
      const result = await exportData(type, filters);
      
      if (result.success) {
        // Mostrar notificación de éxito (opcional)
        console.log('✅ Exportación completada');
      } else {
        // Mostrar notificación de error (opcional)
        console.error('❌ Error en exportación:', result.message);
        alert(`Error al exportar: ${result.message}`);
      }
    } catch (error) {
      console.error('❌ Error inesperado:', error);
      alert('Error inesperado al exportar datos');
    } finally {
      setIsExporting(false);
    }
  };

  const getButtonText = () => {
    if (isExporting) return 'Exportando...';
    
    switch (type) {
      case 'campaigns':
        return 'Exportar Campañas';
      case 'revenue-per-day':
        return 'Exportar Revenue';
      case 'overview':
        return 'Exportar Overview';
      default:
        return 'Exportar';
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className={`
        inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md
        text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-colors duration-200
        ${className}
      `}
    >
      {isExporting ? (
        <>
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Exportando...
        </>
      ) : (
        <>
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {children || getButtonText()}
        </>
      )}
    </button>
  );
};
